import React from 'react';
import { Helmet } from 'react-helmet';

const defaultFav = require('../../resources/icons/default-favicon.ico');
const greenFav = require('../../resources/icons/green-favicon.ico');
const yellowFav = require('../../resources/icons/yellow-favicon.ico');
const redFav = require('../../resources/icons/red-favicon.ico');
const readyFav = require('../../resources/icons/loading-favicon.ico');

type Status = 'default' | 'green' | 'yellow' | 'ready' | 'red';

interface Props {
  title?: string;
  favicon?: string;
  siteTitle: string;
  status?: Status;
}

function selectedFavicon(status: Status): string {
  switch (status) {
    case 'default':
      return defaultFav;
    case 'green':
      return greenFav;
    case 'ready':
      return readyFav;
    case 'yellow':
      return yellowFav;
    case 'red':
      return redFav;
  }
}

export default function Head({ title, siteTitle, status = 'default' }: Props) {
  return (
    <Helmet>
      <title>
        {title ? `${title} | ` : ``}
        {siteTitle} | Statens Vegvesen
      </title>
      <link rel="shortcut icon" type="image/x-icon" href={selectedFavicon(status)}></link>
    </Helmet>
  );
}
